import { createSelector } from 'reselect'

const getOnboardingData = state => state.onboarding

const onboardingInterestsSelector = createSelector(
	[getOnboardingData],
	onboarding => {
		const interestsAbbreviations = ['participation', 'assessment', 'vr', 'store', 'create']
		const interestsString = onboarding.interests.concat().sort().map(function(index) {
			return interestsAbbreviations[index]
		}).join(',')
		return {

			interestsIds: interestsString,
		}
	}
)

export default onboardingInterestsSelector
